import Header from "pages/ManagementPage/Header/Header";

export default Header;
